module.exports = __webpack_public_path__ + "static/img/avatar.ee5d8669.png";